import { useEffect } from "react";

// Spec: manna-web-ui M-Q1 — Cmd/Ctrl+K toggles the global command palette.
// Unlike `f` (Focus mode), Cmd/Ctrl+K must work from inside text inputs —
// it's the primary way users escape a half-typed form to jump elsewhere.
export function useCommandPaletteShortcut(toggle: () => void) {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        toggle();
      }
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [toggle]);
}
